import { useT } from "@/i18n";

// Shown over the S iframe, so it follows S's theme through the S tokens and S's language.
export function SEmbedLoadingState() {
  const { t, dir, language } = useT();
  return (
    <div
      dir={dir}
      lang={language}
      className="flex h-full w-full flex-col items-center justify-center gap-3 rounded-t-lg bg-background p-6 text-sm text-muted-foreground"
    >
      <div className="size-5 animate-spin rounded-full border-2 border-current border-b-transparent" />
      <p>{t("common.loadingEllipsis")}</p>
    </div>
  );
}
